/* eslint-disable eqeqeq */
import { Sticky, StickyContainer } from "react-sticky";
import { BasePage } from "../../../../framework/pages/BasePage";
import { Tabs } from "antd";
import ConfigurarPuntosSection from "../../tabs/ConfigurarPuntosSection";
import ProcedenciaMuestraModal from "../../tabs/ProcedenciaMuestraModal";
import EquiposUtilizadosModal from "../../tabs/EquiposUtilizadosModal";
import OtrosDatosModal from "../../tabs/OtrosDatosModal";
import DatosServisiosModal from "../../tabs/DatosServisiosModal";
import { withRouter } from "react-router-dom/cjs/react-router-dom.min";
import { DATE_FORMAT, PAGE_MODE } from "../../../../constants/constants";
import { DetalleMuestreoModal } from "../../tabs/DetalleMuestreoModal";
import { ModalContext } from "../../../../provider/ModalProvider";
import { COLUMN_DEFAULT } from "../../../../framework/grid/GridFw";
import { AgregarEstacionModal } from "../../../servicios-ejecutados/tabs/PlanificacionSejecutados/modals/AgregarEstacionModal";
import { MessageUtil } from "../../../../util/MessageUtil";
import { LoadUtil } from "../../../../framework/util/LoadUtil";
import { RequestUtil } from "../../../../util/RequestUtil";
import { EnvConstants } from "../../../../EnvConstants";
import { EditarEstacionModal } from "../../../servicios-ejecutados/tabs/PlanificacionSejecutados/modals/EditarEstacionModal";
import { SubparametroResultadosRuidoModal } from "./SubparametroResultadosRuidoModal";

class CadenaRuidoPage extends BasePage {
  static contextType = ModalContext;

  constructor(props) {
    super(props);
    this.state = {
      id_doc: null,
      keyPanel: "1",
    };
    this.cambiarTabPanel = this.cambiarTabPanel.bind(this);
  }

  cambiarTabPanel(tab, id_doc) {
    this.setState({
      id_doc: id_doc,
      keyPanel: tab,
      keyPrincipal: tab,
    });
  }

  renderPage(pageApi, keyPanel) {
    const { TabPane } = Tabs;
    const getgrid_detalle_muestreo = () =>
      pageApi.getComponent("gridDetalleMuestreo");
    const getFormVerificacionEquipos = () =>
      pageApi.getComponent("formVerificacionEquipos");

    const ConfiguracionModalConfig = (data) => {
      const { showModal } = this.context;
      let obj = { id_cadena: pageApi.getParamId() };
      obj = {
        data: {
          ...obj,
          ...data,
        },
        guardarCambios: (value) => {
          getgrid_detalle_muestreo().updateItem({
            ...data,
            condiciones_metereologicas: value,
          });
          getgrid_detalle_muestreo().save();
        },
      };

      showModal({
        width: 800,
        maskClosable: false,
        component: (
          <SubparametroResultadosRuidoModal
            name={obj}
            getParentApi={pageApi.getApi}
          />
        ),
      });
    };

    const ConfigEstacionModal = (data, esNuevo = true, id_estacion = 0) => {
      const { showModal } = this.context;
      let obj = {};

      obj = {
        fnUpdateItem,
        data: {
          ...data,
          id_tipo_matriz:
            getgrid_detalle_muestreo()?.itemEditing?.id_tipo_matriz,
          id_empresa: getgrid_detalle_muestreo()?.itemEditing.id_empresa,
          id_estacion: id_estacion,
        },
      };

      showModal({
        title: esNuevo ? "Agregar Estación" : "Editar Estación",
        width: 350,
        maskClosable: true,
        closable: false,
        background: "white",
        component: esNuevo ? (
          <AgregarEstacionModal name={obj} getParentApi={pageApi.getApi} />
        ) : (
          <EditarEstacionModal name={obj} getParentApi={pageApi.getApi} />
        ),
      });
    };

    const fnUpdateItem = (data) => {
      this.context.hideModal();
      getgrid_detalle_muestreo().saveItemEditing();
      const arrMuestreo = getgrid_detalle_muestreo().getData();

      setTimeout(() => {
        arrMuestreo.forEach((el) => {
          if (data.key == el.key) {
            getgrid_detalle_muestreo().updateItem({
              ...el,
              id_estacion: data.id_estacion,
              estaciondes: data.estaciondes,
              descripcion: data.descripcion,
              georeferencia: data.georeferencia,
            });
          } else {
            getgrid_detalle_muestreo().updateItem(el);
          }
        });
      }, 0);
    };

    const gridDetalleMuestreo = (pageApi) => ({
      title: "Detalles de Muestreo",
      showIndex: true,
      autoLoad: true,
      pagination: {
        server: false,
        showSizeChanger: true,
      },
      rowId: "id_muestreo",
      load: {
        queryId: 929,
        params: () => {
          return {
            ID_CADENA: pageApi.getParamId(),
            id_doc: pageApi.name?.id_ss,
          };
        },
        hideMessage: true,
        hideMessageError: true,
      },
      save: {
        queryId: 895,
        hideMessage: true,
        hideMessageError: true,
        params: { ID_CADENA: pageApi.getParamId() },
        fnOk: () => {
          getgrid_detalle_muestreo().load();
        },
      },
      fields: [
        { name: "muestra", label: "Cod. Muestra" },
        {
          type: "select",
          name: "id_estacion",
          labelName: "estaciondes",
          label: "Estación",
          column: 3,
          load: {
            queryId: 846,
            params: () => {
              return {
                id_empresa: getgrid_detalle_muestreo()?.itemEditing?.id_empresa,
                id_tipo_matriz:
                  getgrid_detalle_muestreo()?.itemEditing?.id_tipo_matriz,
              };
            },
          },
          search: true,
          editable: true,

          onChange: async (value, values, formApi) => {
            if (value == 0) {
              ConfigEstacionModal(formApi.getData(), true);
              formApi.setFieldData("id_estacion", null);
              formApi.setFieldData("descripcion", null);
              formApi.setFieldData("georeferencia", null);
            } else if (value == -1) {
              const id_estacion =
                getgrid_detalle_muestreo()?.itemEditing.id_estacion;
              const estaciondes =
                getgrid_detalle_muestreo()?.itemEditing.estaciondes;

              if (!id_estacion) {
                formApi.setFieldData("id_estacion", null);
                formApi.setFieldData("estaciondes", null);
                formApi.setFieldData("descripcion", null);
                formApi.setFieldData("georeferencia", null);
                return MessageUtil(
                  "warning",
                  "Advertencia",
                  "Debe seleccionar primero una estaciòn para poder editar.",
                );
              }

              fnUpdateItem({ ...formApi.getData(), id_estacion, estaciondes });
              ConfigEstacionModal(
                { ...formApi.getData(), id_estacion, estaciondes },
                false,
                id_estacion,
              );
              formApi.setFieldData("id_estacion", id_estacion);
              formApi.setFieldData("estaciondes", estaciondes);
            } else {
              const id_estacion = value;
              let label = formApi
                ?.getFieldApi("id_estacion")
                ?.getSelectedItem()?.label;
              let descripcion = formApi
                ?.getFieldApi("id_estacion")
                ?.getSelectedItem()?.descripcion;

              const reqParams = LoadUtil.getReqParams({
                queryId: 138,
                params: {
                  ID_ESTACION: id_estacion,
                },
              });

              const data = await RequestUtil.postData(
                EnvConstants.GET_URL_READ(),
                reqParams,
              )
                .then((resp) => resp.dataObject)
                .catch(() => []);
              formApi.setFieldData("georeferencia", `E: ${data?.COORDF || "0"} - N:  ${data?.COORDN || "0"}`);
              formApi.setFieldData("id_estacion", value);
              formApi.setFieldData(
                "estacionDes",
                label || formApi.values.label,
              );
              formApi.setFieldData(
                "descripcion",
                descripcion || formApi.values.descripcion,
              );

              if (formApi.values.id_estacion !== value) {
                fnUpdateItem({
                  ...formApi.getData(),
                  id_estacion,
                  estaciondes: label,
                  descripcion,
                  georeferencia: `E: ${data?.COORDF || "0"} - N:  ${data?.COORDN || "0"}`,
                });
              }
            }
          },
        },
        { name: "descripcion", label: "Descripción" },
        {
          type: "select",
          name: "id_tipo_periodo",
          labelName: "tipo_periodo",
          label: "Periodo",
          column: 3,
          load: {
            queryId: 947,
          },
          search: true,
          editable: true,
        },
        {
          type: "date",
          name: "fecha_prevista_muestreo",
          label: "Fecha Inicio",
          editable: true,
          format: DATE_FORMAT.YYYYMMDD,
          inputFormat: DATE_FORMAT.YYYYMMDD,
        },
        {
          type: "date",
          name: "hora_inicio_muestreo",
          label: "Hora Inicio",
          editable: true,
          format: DATE_FORMAT.HHmm,
          inputFormat: DATE_FORMAT.HHmm,
        },
        {
          name: "georeferencia",
          label: "Ubicación Geográfica",
        },
        {
          name: "zonificacion",
          label: "Zonificación de acuerdo al ECA",
          editable: true,
        },
        { name: "fuente_ruido", label: "Fuente Generadora de Ruido", editable: true },
        {
          name: "tiempo_medicion",
          label: "Tiempo de Medición",
          editable: true,
        },
        {
          type: "select",
          name: "es_medida_continua",
          label: "Medición Continua",
          editable: true,
          load: {
            dataList: [
              { value: "MEDIDO", label: "MEDIDO" },
              { value: "NO MEDIDO", label: "NO MEDIDO" },
            ],
          },
        },
        {
          ...COLUMN_DEFAULT.CHECK,
          label: "Opciones",
          title: "Ingresar Resultados",
          onClick: (value, row) => {
            ConfiguracionModalConfig(row);
          },
        },
        {
          ...COLUMN_DEFAULT.ADD,
          label: "Replicar",
          color: "red",
          column: 12,
          onClick: async (value, row, index) => {
            await getgrid_detalle_muestreo().saveItemEditing();
            await getgrid_detalle_muestreo().refresh();
            getgrid_detalle_muestreo()
              .getData()
              .forEach((data) => {
                getgrid_detalle_muestreo().updateItem({
                  ...data,
                  fecha_prevista_muestreo: row.fecha_prevista_muestreo,
                  hora_inicio_muestreo: row.hora_inicio_muestreo,
                  zonificacion: row.zonificacion,
                  fuente_ruido: row.fuente_ruido,
                  tiempo_medicion: row.tiempo_medicion,
                });
              });
          },
        },
      ],
      onComponentLoad: (formApi, pageApi) => {
        if (pageApi.getPageMode() !== PAGE_MODE.NEW) formApi.load();
      },
    });

    const formVerificacionEquipos = (pageApi) => ({
      layout: "vertical",
      load: {
        queryId: 956,
        params: { ID_CADENA: pageApi.getParamId() },
      },
      save: {
        queryId: 957,
        hideMessage: true,
        hideMessageError: true,
        params: { ID_CADENA: pageApi.getParamId() },
        fnOk: () => {
          getFormVerificacionEquipos().load();
        },
      },
      title: "Verificación del Equipo en Campo",
      collapsible: true,
      fields: [
        {
          name: "valor_verificacion_inicial",
          label: "Valor de la verificación inicial",
          column: 4,
        },
        {
          type: "date",
          name: "fecha_verificacion_inicial",
          label: "Fecha",
          format: DATE_FORMAT.YYYYMMDD,
          inputFormat: DATE_FORMAT.YYYYMMDD,
          column: 4,
        },
        {
          type: "date",
          name: "hora_verificacion_inicial",
          label: "Hora",
          format: DATE_FORMAT.HHmm,
          inputFormat: DATE_FORMAT.HHmm,
          column: 4,
        },
        {
          name: "valor_verificacion_final",
          label: "Valor de la verificación Final",
          column: 4,
        },
        {
          type: "date",
          name: "fecha_verificacion_final",
          label: "Fecha",
          column: 4,
          format: DATE_FORMAT.YYYYMMDD,
          inputFormat: DATE_FORMAT.YYYYMMDD,
        },
        {
          type: "date",
          name: "hora_verificacion_final",
          label: "Hora",
          column: 4,
          format: DATE_FORMAT.HHmm,
          inputFormat: DATE_FORMAT.HHmm,
        },
      ],
      onComponentLoad: (formApi, pageApi) => {
        if (pageApi.getPageMode() !== PAGE_MODE.NEW) formApi.load();
      },
    });

    const renderTabBar = (props, DefaultTabBar) => (
      <Sticky bottomOffset={80}>
        {({ style }) => (
          <DefaultTabBar
            {...props}
            className="site-custom-tab-bar"
            style={style}
          />
        )}
      </Sticky>
    );

    const gridsConfigDetalleMuestreo = [
      {
        name: "gridDetalleMuestreo",
        config: gridDetalleMuestreo(pageApi),
        type: "grid",
      },
    ];

    const gridsEquipos = [
      {
        name: "formVerificacionEquipos",
        config: formVerificacionEquipos(pageApi),
        type: "form",
      },
    ];

    return (
      <StickyContainer>
        <Tabs
          destroyInactiveTabPane={true}
          activeKey={this.state.keyPanel}
          renderTabBar={renderTabBar}
          onChange={(key) => this.setState({ keyPanel: key })}
        >
          <TabPane tab="Configurar Puntos" key="1">
            <ConfigurarPuntosSection
              api={pageApi}
              name={{...pageApi.name}}
              cambiarTabPanel={this.cambiarTabPanel}
              history={this.props.history}
            />
          </TabPane>

          <TabPane
            tab="Datos del Servicio"
            key="2"
            disabled={parseInt(pageApi.getParamId()) === 0 ? true : false}
          >
            <DatosServisiosModal
              api={pageApi}
              name={{...pageApi.name}}
              cambiarTabPanel={this.cambiarTabPanel}
              history={this.props.history}
            />
          </TabPane>

          <TabPane
            tab="Procedencia de la muestra"
            key="3"
            disabled={parseInt(pageApi.getParamId()) === 0 ? true : false}
          >
            <ProcedenciaMuestraModal
              api={pageApi}
              name={{...pageApi.name}}
              cambiarTabPanel={this.cambiarTabPanel}
              history={this.props.history}
            />
          </TabPane>

          <TabPane
            tab="Detalle del muestreo"
            key="4"
            disabled={parseInt(pageApi.getParamId()) === 0 ? true : false}
          >
            <DetalleMuestreoModal
              api={pageApi}
              data={{ ...pageApi.name }}
              cambiarTabPanel={this.cambiarTabPanel}
              history={this.props.history}
              gridsConfig={gridsConfigDetalleMuestreo}
            />
          </TabPane>

          <TabPane
            tab="Equipos Utilizados"
            key="5"
            disabled={parseInt(pageApi.getParamId()) === 0 ? true : false}
          >
            <EquiposUtilizadosModal
              api={pageApi}
              name={{...pageApi.name}}
              cambiarTabPanel={this.cambiarTabPanel}
              history={this.props.history}
              gridsConfig={gridsEquipos}
            />
          </TabPane>

          <TabPane
            tab="Otros Datos"
            key="6"
            disabled={parseInt(pageApi.getParamId()) === 0 ? true : false}
          >
            <OtrosDatosModal
              api={pageApi}
              name={{...pageApi.name}}
              cambiarTabPanel={this.cambiarTabPanel}
              history={this.props.history}
            />
          </TabPane>
        </Tabs>
      </StickyContainer>
    );
  }
}

export default withRouter(CadenaRuidoPage);
